import React, { PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'

import { TrackedRoute } from '@components/UI/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectCollabsCount, selectIdentityGroupCount } from '@store/brandFans'
import {
  selectBrandFansCurrentView,
  selectCurrentBrandFansBrandFilter,
  selectCurrentBrandFansSort,
} from '@store/router'
import { selectIdentityBrandFanGroupIds } from '@store/submissions'

interface IProps {
  eventName: EventTrackingNames
  identityId: number
  submissionId?: number
  additionalProperties?: any
  hasTracking?: boolean
  disabled?: boolean
}

const BrandFanInfluencerIdentityRowTrackedRoute: React.FC<PropsWithChildren<IProps>> = ({
  identityId,
  submissionId,
  eventName,
  additionalProperties,
  disabled,
  children,
}) => {
  const sortFilter = useSelector((state: IApplicationState) => selectCurrentBrandFansSort(state))
  const collabsCount = useSelector((state: IApplicationState) =>
    selectCollabsCount(state, identityId),
  )
  const brandFilter = useSelector((state: IApplicationState) =>
    selectCurrentBrandFansBrandFilter(state),
  )
  const currentView = useSelector((state: IApplicationState) => selectBrandFansCurrentView(state))
  const groupCount = useSelector((state: IApplicationState) =>
    submissionId
      ? selectIdentityBrandFanGroupIds(state, submissionId)
      : selectIdentityGroupCount(state, identityId),
  )

  if (disabled) {
    return children
  }

  const brandFansOnlyProps = submissionId
    ? {}
    : {
        sort_filter: sortFilter,
        brand_filter: brandFilter,
        number_of_collabs: collabsCount,
      }

  return (
    <TrackedRoute
      eventName={eventName}
      properties={{
        identity_id: identityId,
        current_filter: currentView,
        number_of_groups_selected: groupCount,
        ...brandFansOnlyProps,
        ...additionalProperties,
      }}
    >
      {children}
    </TrackedRoute>
  )
}

export { BrandFanInfluencerIdentityRowTrackedRoute }
export default BrandFanInfluencerIdentityRowTrackedRoute
